import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./pages/common/login/login.component";
import { AuthGuard } from "./auth/auth.guard";
import { FormDeactivateGuard } from "./common/guards/form-deactivate.guard";
import { EmployeeComponent } from "./pages/common/employees/employee/employee.component";
import { SystemComponent } from "./pages/common/system/system/system.component";
import { ProductComponent } from "./pages/common/products/product/product.component";
import { PromotionComponent } from "./pages/common/promotions/promotion/promotion.component";
import { ReportComponent } from "./pages/common/reports/report/report.component";
import { UserComponent } from "./pages/common/users/user/user.component";
import { DepartmentEditComponent } from "./pages/common/system/department/department-edit/department-edit.component";
import { DepartmentComponent } from "./pages/common/system/department/department.component";
import { EmployeeCategoryEditComponent } from "./pages/common/employees/employee-category/employee-category/employee-category-edit/employee-category-edit.component";
import { EmployeeCategoryComponent } from "./pages/common/employees/employee-category/employee-category/employee-category.component";
import { AreaComponent } from "./pages/common/system/area/area.component";
import { AreaEditComponent } from "./pages/common/system/area/area-edit/area-edit/area-edit.component";
import { ShopinfoComponent } from "./pages/common/system/shopinfo/shopinfo.component";
import { ShopEditComponent } from "./pages/common/system/shopinfo/shop-edit/shop-edit.component";
import { SystemSettingsComponent } from "./pages/common/system/system-settings/system-settings.component";
import { UomComponent } from "./pages/common/products/uom/uom.component";
import { ItemCategoryEditComponent } from "./pages/common/products/item-category/item-category-edit/item-category-edit.component";
import { ItemCategoryComponent } from "./pages/common/products/item-category/item-category.component";
import { SaleItemEditComponent } from "./pages/common/products/sale-item/sale-item-edit/sale-item-edit.component";
import { SaleItemComponent } from "./pages/common/products/sale-item/sale-item.component";
import { SaleItemBulkUpdateComponent } from "./pages/common/products/sale-item-bulk-update/sale-item-bulk-update.component";
import { StockCategoryEditComponent } from "./pages/common/products/stock-category/stock-category/stock-category-edit/stock-category-edit.component";
import { StockCategoryComponent } from "./pages/common/products/stock-category/stock-category/stock-category.component";
import { StocksEditComponent } from "./pages/common/products/stocks/stocks/stocks-edit/stocks-edit.component";
import { StocksComponent } from "./pages/common/products/stocks/stocks/stocks.component";
import { UomEditComponent } from "./pages/common/products/uom/uom-edit/uom-edit.component";
import { WeeklyResultByStoreReportComponent } from "./pages/common/reports/weekly-result-by-store-report/weekly-result-by-store-report.component";
import { WeeklyResultByStoreReportViewComponent } from "./pages/common/reports/weekly-result-by-store-report/weekly-result-by-store-report-view/weekly-result-by-store-report-view.component";
import { YtdResultByStoreComponent } from "./pages/common/reports/ytd-result-by-store/ytd-result-by-store.component";
import { WeeklyResultByBranchComponent } from "./pages/common/reports/weekly-result-by-branch/weekly-result-by-branch.component";
import { YtdResultByBranchComponent } from "./pages/common/reports/ytd-result-by-branch/ytd-result-by-branch.component";
import { YtdResultByStoreViewComponent } from "./pages/common/reports/ytd-result-by-store/ytd-result-by-store-view/ytd-result-by-store-view.component";
import { WeeklyResultByBranchViewComponent } from "./pages/common/reports/weekly-result-by-branch/weekly-result-by-branch-view/weekly-result-by-branch-view.component";
import { YtdResultByBranchViewComponent } from "./pages/common/reports/ytd-result-by-branch/ytd-result-by-branch-view/ytd-result-by-branch-view.component";
import { WeeklyReportComponent } from "./pages/common/reports/weekly-report/weekly-report.component";
import { TerminalComponent } from "./pages/common/system/terminal/terminal.component";
import { KitchenComponent } from "./pages/common/system/kitchen/kitchen.component";
import { kitchenEditComponent } from "./pages/common/system/kitchen/kitchen-edit/kitchen-edit.component";
import { OrderComponent } from "./pages/common/reports/order/order.component";
import { WeeklySalesComponent } from "./pages/shop/reports/weekly-sales/weekly-sales.component";
import { HourlySalesReportComponent } from "./pages/shop/reports/hourly-sales-report/hourly-sales-report.component";
import { TerminalEditComponent } from "./pages/common/system/terminal/terminal-edit/terminal-edit.component";
import { OrderSummaryComponent } from "./pages/common/reports/order/order-summary/order-summary.component";
import { DailySalesComponent } from "./pages/shop/reports/daily-sales/daily-sales.component";
import { AccessLogComponent } from "./pages/shop/reports/access-log/access-log.component";
import { DailySalesReportComponent } from "./pages/common/reports/daily-sales-report/daily-sales-report.component";
import { ExpenseDetailsReportComponent } from "./pages/shop/reports/expense-details-report/expense-details-report.component";
import { MasterSalesReportCostComponent } from "./pages/shop/reports/master-sales-report-cost/master-sales-report-cost.component";
import { DayEndReportComponent } from "./pages/shop/reports/day-end-report/day-end-report.component";
import { WeeklyCashAndBankingReportComponent } from "./pages/shop/reports/weekly-cash-and-banking-report/weekly-cash-and-banking-report.component";
import { CashVarianceExceptionReportComponent } from "./pages/common/reports/cash-variance-exception-report/cash-variance-exception-report.component";
import { AttendanceExceptionReportComponent } from "./pages/common/reports/attendance-exception-report/attendance-exception-report.component";
import { HqDailySalesComponent } from "./pages/common/reports/daily-sales/daily-sales.component";
import { HqWeeklySalesComponent } from "./pages/common/reports/weekly-sales/weekly-sales.component";
import { ExpenseTypeSummaryReportComponent } from "./pages/common/reports/expense-type-summary-report/expense-type-summary-report.component";
import { ExpenseComponent } from "./pages/common/system/expense/expense.component";
import { ExpenseEditComponent } from "./pages/common/system/expense/expense-edit/expense-edit.component";
import { ExpenseTypeComponent } from "./pages/common/system/expense-type/expense-type.component";
import { ExpenseTypeEditComponent } from "./pages/common/system/expense-type/expense-edit/expense-type-edit.component";
import { ReasonsComponent } from "./pages/common/system/reasons/reasons.component";
import { ReasonsEditComponent } from "./pages/common/system/reasons/reasons-edit/reasons-edit.component";
import { MenuComponent } from "./pages/common/products/menu/menu.component";
import { MenuEditComponent } from "./pages/common/products/menu/menu-edit/menu-edit.component";
import { UserGroupEditComponent } from "./pages/common/users/usergroup/usergroup-edit/usergroup-edit.component";
import { YearlyResultByWeekReportComponent } from "./pages/common/reports/yearly-result-by-week-report/yearly-result-by-week-report.component";
import { YearlyResultByWeekReportShopComponent } from "./pages/shop/reports/yearly-result-by-week-report-shop/yearly-result-by-week-report-shop.component";
import { MasterSalesReportComponent } from "./pages/common/reports/master-sales-report/master-sales-report.component";
import { AutoDiscountEditComponent } from "./pages/common/promotions/auto-discount/auto-discount-edit/auto-discount-edit.component";
import { AutoDiscountComponent } from "./pages/common/promotions/auto-discount/auto-discount.component";

import { CustomizationComponent } from "./pages/common/products/customization/customization.component";
import { CustomizationEditComponent } from "./pages/common/products/customization/customization-edit/customization-edit.component";
import { ComboComponent } from "./pages/common/products/combo/combo.component";
import { ComboEditComponent } from "./pages/common/products/combo/combo-edit/combo-edit.component";
import { SalesReportByGroupComponent } from "./pages/shop/reports/sales-report-by-group/sales-report-by-group.component";
import { ItemClassDisplayOrderComponent } from "./pages/common/products/item-class-display-order/item-class-display-order.component";
import { SaleItemDisplayOrderComponent } from "./pages/common/products/sale-item-display-order/sale-item-display-order.component";
import { HotItemDisplayOrderComponent } from "./pages/common/products/hot-item-display-order/hot-item-display-order.component";
import { ItemDiscountDisplayOrderComponent } from "./pages/common/promotions/item-discount-display-order/item-discount-display-order.component";
import { UnderConstructionComponent } from "./pages/common/under-construction/under-construction.component";
import { DiscountComponent } from "./pages/common/promotions/discount/discount.component";
import { DiscountEditComponent } from "./pages/common/promotions/discount/discount-edit/discount-edit.component";
import { TerminalSyncLogComponent } from "./pages/common/utils/terminal-sync-log/terminal-sync-log.component";
import { EmployeeEditComponent } from "./pages/common/employees/employee/employee-edit/employee-edit.component";
import { EmployeeExtComponent } from "./pages/common/employees/employee-ext/employee-ext.component";
import { EmployeeExtEditComponent } from "./pages/common/employees/employee-ext/employee-ext-edit/employee-ext-edit.component";
import { UserEditComponent } from "./pages/common/users/user/user-edit/user-edit.component";
import { VoucherComponent } from "./pages/common/promotions/voucher/voucher.component";
import { VoucherEditComponent } from "./pages/common/promotions/voucher/voucher-edit/voucher-edit.component";
import { CustomMenuComponent } from "./pages/common/users/custom-menu/custom-menu.component";
import { UsergroupPermissionsComponent } from "./pages/common/users/usergroup/usergroup-permissions/usergroup-permissions.component";
import { CustomMenuItemComponent } from "./pages/common/users/custom-menu-item/custom-menu-item.component";
import { AreaManagerShopComponent } from "./pages/common/users/area-manager-shop/area-manager-shop.component";
import { StaffAttendanceComponent } from "./pages/shop/people/staff-attendance/staff-attendance.component";
import { VersionUpdaterComponent } from "./pages/common/utils/version-updater/version-updater.component";
import { VersionUpdatedShopListComponent } from "./pages/common/utils/version-updater/version-updated-shop-list/version-updated-shop-list.component";
import { DashboardComponent } from "./pages/common/dashboard/dashboard.component";
import { AccessDeniedComponent } from "./pages/common/access-denied/access-denied.component";
import { ItemClassComponent } from "./pages/common/products/item-class/item-class.component";
import { ItemClassEditComponent } from "./pages/common/products/item-class/item-class-edit/item-class-edit.component";
import { PayrollMenuComponent } from "./pages/common/payroll/payroll-menu/payroll-menu.component";
import { AttendanceExportComponent } from "./pages/common/payroll/attendance-export/attendance-export.component";
import { PayrollGroupEditComponent } from "./pages/common/payroll/payroll-group/payroll-group-edit/payroll-group-edit.component";
import { PayrollGroupComponent } from "./pages/common/payroll/payroll-group/payroll-group.component";
import { ShopPayrollSettingsEditComponent } from "./pages/common/payroll/shop-payroll-settings/shop-payroll-settings-edit/shop-payroll-settings-edit.component";
import { ShopPayrollSettingsComponent } from "./pages/common/payroll/shop-payroll-settings/shop-payroll-settings.component";
import { StaffPayrollGroupEditComponent } from "./pages/common/payroll/staff-payroll-group/staff-payroll-group-edit/staff-payroll-group-edit.component";
import { StaffPayrollGroupComponent } from "./pages/common/payroll/staff-payroll-group/staff-payroll-group.component";
import { StaffAttendanceEditComponent } from "./pages/shop/people/staff-attendance/staff-attendance-edit/staff-attendance-edit.component";
import { SubMenuLayoutComponent } from "./common/layouts/sub-menu-layout/sub-menu-layout.component";
import { UserGroupComponent } from "./pages/common/users/usergroup/usergroup.component";
import { AdsSettingsEditComponent } from "./pages/common/utils/ads-settings/components/ads-settings-edit/ads-settings-edit.component";
import { SyncErrorComponent } from "./pages/common/utils/sync-error/sync-error.component";
import { AdsSettingsComponent } from "./pages/common/utils/ads-settings/ads-settings.component";
import { EmployeeJobPositionComponent } from "./pages/common/employees/employee-job-position/employee-job-position/employee-job-position.component";
import { EmployeeJobPositionEditComponent } from "./pages/common/employees/employee-job-position/employee-job-position-edit/employee-job-position-edit.component";
import { EmployeeJobTitleComponent } from "./pages/common/employees/employee-job-title/employee-job-title/employee-job-title.component";
import { EmployeeJobTitleEditComponent } from "./pages/common/employees/employee-job-title/employee-job-title-edit/employee-job-title-edit.component";
import { EmployeeStatusComponent } from "./pages/common/employees/employee-status/employee-status/employee-status.component";
import { EmployeeStatusEditComponent } from "./pages/common/employees/employee-status/employee-status-edit/employee-status-edit.component";

const routes: Routes = [

  { path: "", redirectTo: "login", pathMatch: "full" },
  { component: LoginComponent, path: "login" },


  // System Menu
  {
    path: "system",
    component: SubMenuLayoutComponent,
    data: { menuType: 'system' },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "",
        component: SystemComponent,
      },
      {
        path: "department-edit/:id",
        component: DepartmentEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "department",
        component: DepartmentComponent,
      },
      {
        path: "region",
        component: AreaComponent,
      },
      {
        path: "region-edit/:id",
        component: AreaEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "expense",
        component: ExpenseComponent,
      },
      {
        path: "expense-edit/:id",
        component: ExpenseEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "expense/expense-type",
        component: ExpenseTypeComponent,
      },
      {
        path: "expense-type-edit/:id",
        component: ExpenseTypeEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "reason",
        component: ReasonsComponent,
      },
      {
        path: "reason-edit/:id",
        component: ReasonsEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "shop",
        component: ShopinfoComponent,
      },
      {
        path: "shop-edit/:id",
        component: ShopEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "system-settings",
        component: SystemSettingsComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "station",
        component: TerminalComponent,
      },
      {
        path: "station-edit/:id",
        component: TerminalEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "kitchen",
        component: KitchenComponent,
      },
      {
        path: "kitchen-edit/:id",
        component: kitchenEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
    ]
  },


  // Report Menu
  {
    path: "report",
    component: SubMenuLayoutComponent,
    data: { menuType: 'report' },
    canActivateChild: [AuthGuard],
    children: [
      {
        component: YearlyResultByWeekReportComponent,
        path: "yearly-result-by-week-hq",
      },
      {
        component: MasterSalesReportComponent,
        path: "master-sales-report",
      },
      {
        component: SalesReportByGroupComponent,
        path: "sales-report-by-groups",
      },
      {
        component: WeeklyResultByStoreReportComponent,
        path: "weekly-result-by-store",
      },
      {
        component: WeeklyResultByStoreReportViewComponent,
        path: "weekly-result-by-store-view",
      },
      {
        component: YtdResultByStoreComponent,
        path: "ytd-result-by-store",
      },
      {
        component: YtdResultByStoreViewComponent,
        path: "ytd-result-by-store-view",
      },
      {
        component: WeeklyResultByBranchComponent,
        path: "weekly-result-by-branch",
      },
      {
        component: WeeklyResultByBranchViewComponent,
        path: "weekly-result-by-branch-view",
      },
      {
        component: YtdResultByBranchComponent,
        path: "ytd-result-by-branch",
      },
      {
        component: YtdResultByBranchViewComponent,
        path: "ytd-result-by-branch-view",
      },
      {
        component: CashVarianceExceptionReportComponent,
        path: "cash-variance-exception",
      },
      {
        component: AttendanceExceptionReportComponent,
        path: "attendance-exception",
      },
      {
        component: WeeklyReportComponent,
        path: "weekly-report",
      },
      {
        component: OrderComponent,
        path: "orders",
      },
      {
        component: OrderSummaryComponent,
        path: "order-summary/:id",
        canDeactivate: [FormDeactivateGuard],
      },
      {
        component: DailySalesComponent,
        path: "shop-daily-sales",
      },
      {
        component: WeeklySalesComponent,
        path: "weekly-sales-summary-shop",
      },
      {
        component: AccessLogComponent,
        path: "access-log",
      },
      {
        component: HourlySalesReportComponent,
        path: "hourly-sales-report",
      },
      {
        component: DailySalesReportComponent,
        path: "daily-sales-report",
      },
      {
        component: DayEndReportComponent,
        path: "day-end-report",
      },
      {
        component: ExpenseDetailsReportComponent,
        path: "expense-details-report",
      },
      {
        component: MasterSalesReportCostComponent,
        path: "master-sales-report-cost",
      },
      {
        component: WeeklyCashAndBankingReportComponent,
        path: "weekly-cash-and-banking-report",
      },
      {
        component: HqDailySalesComponent,
        path: "daily-sales-summary",
      },
      {
        component: HqWeeklySalesComponent,
        path: "weekly-sales-summary-hq",
      },
      {
        component: ExpenseTypeSummaryReportComponent,
        path: "expense-type-summary",
      },
      {
        component: YearlyResultByWeekReportShopComponent,
        path: "yearly-result-by-week-shop",
      },
    ]
  },


  // Product Menu
  {
    path: "product",
    component: SubMenuLayoutComponent,
    data: { menuType: 'product' },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "menu",
        component: MenuComponent,
      },
      {
        path: "menu-edit/:id",
        component: MenuEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "uom",
        component: UomComponent,
      },
      {
        path: "uom-edit/:id",
        component: UomEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "stocks",
        component: StocksComponent,
      },
      {
        path: "stocks-edit/:id",
        component: StocksEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "stock-category-edit/:id",
        component: StockCategoryEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "stock-category",
        component: StockCategoryComponent,
      },
      {
        path: "item-category",
        component: ItemCategoryComponent,
      },
      {
        path: "item-category-edit/:id",
        component: ItemCategoryEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "sale-item",
        component: SaleItemComponent,
      },
      {
        path: "sale-item-bulk-update",
        component: SaleItemBulkUpdateComponent,
      },
      {
        path: "sale-item-edit/:id",
        component: SaleItemEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "customization",
        component: CustomizationComponent,
      },
      {
        path: "customization-edit/:id",
        component: CustomizationEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "item-class-display-order",
        component: ItemClassDisplayOrderComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "sale-item-display-order",
        component: SaleItemDisplayOrderComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "hot-item-display-order",
        component: HotItemDisplayOrderComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "combo",
        component: ComboComponent,
      },
      {
        path: "combo-edit/:id",
        component: ComboEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "item-class",
        component: ItemClassComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "item-class-edit/:id",
        component: ItemClassEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
    ]
  },


  // Promotion Menu
  {
    path: "promotion",
    component: SubMenuLayoutComponent,
    data: { menuType: 'promotion' },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "item-discount-display-order",
        component: ItemDiscountDisplayOrderComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "discount",
        component: DiscountComponent,
      },
      {
        path: "discount-edit/:id",
        component: DiscountEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "voucher",
        component: VoucherComponent,
      },
      {
        path: "voucher-edit/:id",
        component: VoucherEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "auto-discount",
        component: AutoDiscountComponent,
      },
      {
        path: "auto-discount-edit/:id",
        component: AutoDiscountEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
    ]
  },
  {
    component: UnderConstructionComponent,
    path: "under-construction",
    canActivate: [AuthGuard],
  },


  // User Menu
  {
    path: "user",
    component: SubMenuLayoutComponent,
    data: { menuType: 'user' },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "user",
        component: UserComponent,
      },
      {
        path: "user-edit/:id",
        component: UserEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "user-group",
        component: UserGroupComponent,
      },
      {
        path: "user-group-edit/:id",
        component: UserGroupEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "custom-menu",
        component: CustomMenuComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "custom-menu/menu-item",
        component: CustomMenuItemComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "user-group-permission",
        component: UsergroupPermissionsComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "area-manager",
        component: AreaManagerShopComponent,
        canDeactivate: [FormDeactivateGuard],
      },
    ]
  },

  // Employee Menu
  {
    path: "employee",
    component: SubMenuLayoutComponent,
    data: { menuType: 'employee' },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "employee",
        component: EmployeeComponent,
      },
      {
        path: "employee-edit/:id",
        component: EmployeeEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "employee-ext",
        component: EmployeeExtComponent,
      },
      {
        path: "employee-ext-edit/:id",
        component: EmployeeExtEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "employee-category-edit/:id",
        component: EmployeeCategoryEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "employee-category",
        component: EmployeeCategoryComponent,
      },
      {
        path: "staff-attendance",
        component: StaffAttendanceComponent,
      },
      {
        path: "staff-attendance-edit/:id",
        component: StaffAttendanceEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "employee-job-position",
        component: EmployeeJobPositionComponent,
      },
      {
        path: "employee-job-position-edit/:id",
        component: EmployeeJobPositionEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "employee-job-title",
        component: EmployeeJobTitleComponent,
      },
      {
        path: "employee-job-title-edit/:id",
        component: EmployeeJobTitleEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "employee-status",
        component: EmployeeStatusComponent,
      },
      {
        path: "employee-status-edit/:id",
        component: EmployeeStatusEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
    ]
  },

  // Payroll Menu
  {
    path: "payroll",
    component: SubMenuLayoutComponent,
    data: { menuType: 'payroll' },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "payroll-group",
        component: PayrollGroupComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "payroll-group-edit/:id",
        component: PayrollGroupEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "shop-payroll-setting",
        component: ShopPayrollSettingsComponent,
      },
      {
        path: "shop-payroll-setting-edit/:id",
        component: ShopPayrollSettingsEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "staff-payroll-group",
        component: StaffPayrollGroupComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "payroll-attendance-export",
        component: AttendanceExportComponent,
      },
      {
        path: "staff-payroll-group-edit/:id/:shop_id",
        component: StaffPayrollGroupEditComponent,

      },
    ]
  },
  // utility menu
  {
    path: "utility",
    component: SubMenuLayoutComponent,
    data: { menuType: 'utility' },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "updater",
        component: VersionUpdaterComponent,
      },
      {
        path: "ads-setting",
        component: AdsSettingsComponent
      },
      {
        path: "ads-setting-edit/:id",
        component: AdsSettingsEditComponent,
      },
      {
        path: "updated-shop-list/:updatedVersion",
        component: VersionUpdatedShopListComponent,
      },
      {
        path: "terminal-sync-log",
        component: TerminalSyncLogComponent,
      },
      {

        path: "sync-queue",
        component: SyncErrorComponent,
      },
    ]
  },

  // dashboards
  {
    component: DashboardComponent,
    path: "dashboard-hq",
    canActivate: [AuthGuard],
  },
  {
    component: DashboardComponent,
    path: "dashboard-area",
    canActivate: [AuthGuard],
  },
  {
    component: DashboardComponent,
    path: "dashboard-shop",
    canActivate: [AuthGuard],
  },

  {
    component: AccessDeniedComponent,
    path: "access-denied",
  },
  {
    path: "**",
    redirectTo: "access-denied"
  }



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [FormDeactivateGuard],
})
export class AppRoutingModule { }
